/**
 *  @author:        Cloud for Good
 *  @description:   Applies custom Advancement logic to the Wishlist Cartridge client-side logic.
 *
 *  History
 *  <Date>        <Author Name>       <Reference #>       <Change Description>
 *  2022-09-30    Cloud for Good       N/A                Initial creation
 *  2024-08-30    Jassin Yacks         CFG-489            Enhanced the Heart icon to ensure ADA compliance.
*/

'use strict';

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} icon - icon that was clicked to add a product to the wishlist
 */
function displayMessageAndChangeIcon(data, icon, previousFocus) {
    $.spinner().stop();

    //declare variables
    var status;

    if (data.success) {
        status = 'alert-success';

        //if the heart is not filled in
        if (icon.hasClass('fa-heart-o')) {
            //set the class to 'fa-heart' to fill it in
            icon.removeClass('fa-heart-o').addClass('fa-heart');
            //update aria tag on heart icon button
            icon.closest('button').attr('aria-pressed', true);
            //update title and assistive text
            icon.attr('title', 'Added to favorites');

        }
    } else {
        status = 'alert-danger';
    }

    if ($('.add-to-wishlist-messages').length === 0) {
        $('body').append(
            `<div class="add-to-wishlist-messages alert ${status} alert-dismissible fade show" role="alert">
                <p class="alert-message">${data.msg}</p>
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>`
        );
    }

    $('.add-to-wishlist-messages .close').focus();

    $('.add-to-wishlist-messages .close').on('click keydown', function(e) {
        e.preventDefault();
        if (e.type === "click" || e.keyCode === 13) {
            $('.add-to-wishlist-messages').remove();
            if (previousFocus) {
                previousFocus.focus();
            }
        }
    })
}

module.exports = {
    addToWishlistTile: function () {
        $('body').on('click', 'button.wishlistTile, button.wishlistDetail', function (e) {
            e.preventDefault();
            var previousFocus = $(document.activeElement);
            var icon = $(this).find($('i'));
            var url = $(this).attr('href');
            var pid = $(this).closest('.product').data('pid');
            var optionId = $(this).closest('.product-detail').find('.product-option').attr('data-option-id');
            var optionVal = $(this).closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
            optionId = optionId || null;
            optionVal = optionVal || null;
            if (!url || !pid) {
                return;
            }

            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: {
                    pid: pid,
                    optionId: optionId,
                    optionVal: optionVal
                },
                success: function (data) {
                    displayMessageAndChangeIcon(data, icon, previousFocus);
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        displayMessageAndChangeIcon(err, icon, previousFocus);
                    }
                }
            });
        });
    }
};
